import React, { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useQuestionnaire } from 'hooks/useQuestionnaire';
import { useTabContext } from 'context/TabContext';
import { Box, Button, Text } from '@chakra-ui/react';
import Heading from 'components/Heading/Heading';
import Checkbox from 'components/Checkbox/Checkbox';
import SectionComponent from 'components/SectionComponent/SectionComponent';
import { useLoading } from 'hooks/useLoading';
import { useSession } from 'context/SessionContext';
import { Section } from 'types';
import { useUserSession } from 'context/UserContext';
import { initializeDefaultValues, resetFormValues } from 'utils/formUtils';
import { fetchQuestions as handleFetchQuestions } from 'hooks/useFetchQuestions';


interface Medical {
  onSubmitFormHandle: (event: any, question: any, handleNext: any, handleSubmit: any, setError: any, message?: string) => void;
}


const Medical: React.FC<Medical> = ({onSubmitFormHandle}) => {
  const { completeTab, activeTab, loading, setLoading, enabledTabs } = useTabContext();
  const { startLoading, stopLoading, LoadingSpinner } = useLoading();
  const [medicalData, setMedicalData] = useState<Section[]>([]);
  const { saveQuestionnaire } = useSession();

  const { validateStep, validateInputs, validateSubQuestion, editValues } =
    useQuestionnaire();

  const {
    control,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
    setValue,
    setError,
  } = useForm()

  const currentTab = 2;
  const { userData, getDynamicQuestionnaire } = useUserSession();
  const questionnaireCode = useMemo(() => getDynamicQuestionnaire('MED')?.value ?? '', [userData])

  useEffect(() => {
    if (activeTab === currentTab && medicalData.length === 0) {
      const fetchQuestions = async () => {
        startLoading();
        try {
           const { sections } = await handleFetchQuestions(questionnaireCode, 'A');

          setMedicalData(sections);
        } catch (error: any) {
        } finally {
          stopLoading();
        }
      };

      fetchQuestions();
    }
  }, [activeTab]);

    useEffect(() => {
      if (!enabledTabs.includes(currentTab)) {
        resetFormValues(medicalData, setValue, reset, initializeDefaultValues(medicalData));
      }
    }, [enabledTabs]);
  
  const handleNext = async () => {
    setLoading(true);


    const values = getValues();
    validateStep(values);
    const answersArray = editValues(getValues);

    const answerData = {
      questionnaireId: questionnaireCode,
      activityCode: 'A',
      answers: [...answersArray],
    };

    saveQuestionnaire(answerData);
    
    try {
      completeTab(activeTab);
    } catch (error) {
      console.error('Erro ao enviar dados:', error);
    } finally {
      setLoading(false);
    }
  };


  function DialogText(){
      let lines = userData?.additionalInformations.find((x: any) => x.code === 'DECLARACAO_VERACIDADE');
  
      return (
        <>
          {
            lines.descriptions.map((element:any) => (
             
              <Text key={element.value} fontSize="md" marginTop="15px" color="brand.fontColors.primary" fontWeight={500} >
                         {element.value}
              </Text>
              
            ))
          }
        </>
      )
    }

function onSubmitHandle(event: React.FormEvent<HTMLFormElement>) {
  onSubmitFormHandle(event, medicalData, handleNext, handleSubmit, setError, 'Não foi selecionada nenhuma doença');
}

  return (
    <Box>
      <Box>
        <Heading title="Questionário Médico" />
      </Box>
      <Box>
        <form onSubmit={onSubmitHandle}>
          {medicalData.map(sectionList => (
            <SectionComponent
              key={sectionList.code}
              sectionList={sectionList}
              control={control}
              validateInputs={validateInputs}
              getValues={getValues}
              validateSubQuestion={validateSubQuestion}
              errors={errors}
              handleDataChange={setMedicalData}
              dataListChange={medicalData}
            />
          ))}

          {DialogText()}
          

          <Checkbox
            name="confirmInfo3"
            control={control}
            label="Confirmo a Informação"
            rules={{ required: 'Campo de preenchimento obrigatório' }}
            error={errors?.['confirmInfo3']}
          />

          <Box display="flex" alignItems="center" justifyContent="flex-end">
            <Button
              variant={'primary'}
              type="submit"
              isLoading={loading}
              loadingText="A Enviar"
            >
              <span>Continuar</span>
            </Button>
          </Box>
        </form>
      </Box>
      <LoadingSpinner />
    </Box>
  );
};

export default Medical;
